import { Component, OnInit } from '@angular/core';
import { AfterViewInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { formatDate, DatePipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { APIService } from '../api.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';
import { VoucherEntryComponent } from '../voucher-entry/voucher-entry.component';

import { CommonService } from '../services/common.service';
import { DataService } from '../services/data.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-reconciliation',
  templateUrl: './reconciliation.component.html',
  styleUrls: ['./reconciliation.component.scss']
})
export class ReconciliationComponent implements AfterViewInit, OnInit {

  //@ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }
  displayedColumns: string[] = ['EffectiveDate', 'VoucherNum', 'PaymentMode', 'PaymentRef', 'MainLedger', 'CrAmt', 'DbAmt', 'CloBal', 'ReconDate', 'Actions'];
  dataSource: any = [];

  pipe = new DatePipe('en-IN');
  now: any = Date.now();
  lastMonth: any = new Date(new Date().getFullYear(), new Date().getMonth() + 0, 1);
  startDate: any = new Date(new Date(this.lastMonth));
  endDate: any = new Date(new Date());
  IsEdit: any = false;
  jarvisData: any = [];
  agencyData: any = [];
  bankBalance: number = 0;
  tempdata: Array<any> = [];
  bankList: any;
  bankLedgerID: number = 0;
  bankName: string = "";
  modalReference: any;
  closeResult: string = '';
  VoucherID: any;
  EffectiveDate: any;
  exportToExcel: any = [];
  isAdmin: boolean = false;
  maxDate = new Date();
  isWeb: boolean = true;
  right: any = [];

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
        , base64 = function (s:any) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s:any, c:any) { return s.replace(/{(\w+)}/g, function (m:any, p:any) { return c[p]; }) }

    return function (table: any, name : string, fileName:any) {
        if (!table.nodeType) table = table
        var ctx = { worksheet: name || 'Worksheet', table: table }
        //window.location.href = uri + base64(format(template, ctx))
        var link = document.createElement("a");
        link.download = fileName || 'download.xls';
        link.href = uri + base64(format(template, ctx));
        link.click();
    }
  })()


  constructor(private dateAdapter: DateAdapter<Date>, private apiService: APIService, private appService: DataService, private modalService: NgbModal, private router: Router, private SpinnerService: NgxSpinnerService) {
    this.dateAdapter.setLocale('en-IN');
  }

  ngOnInit(): void {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    this.right = this.apiService.getCookie("J");
    if (this.right) {
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function (o: any) { return o.UserID == ownUserID })[0];
    }

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    if (this.agencyData.length > 0 && this.jarvisData.length > 0) {
      this.isAdmin = (this.agencyData[0].AdminUserID == this.jarvisData[0].UserID) ? true : false;
    }

    let bankList = this.apiService.getCookie("ERP_Cfg");
    debugger
    if (bankList) {
      bankList = JSON.parse(bankList)[0].BankLedgers;
      if (bankList) {
        this.bankList = JSON.parse(bankList);
      }
    }

    if (this.bankList.length == 1) {
      this.bankName = this.bankList[0].LNm;
      this.bankLedgerID = this.bankList[0].LID;

      this.getAPIData();
    }
    //this.getAPIData();
  }

  changeLedger() {
    if (this.bankName) {
      let bankName = this.bankName;
      let bankList = $.grep(this.bankList, function (i: any) {
        return i.LNm == bankName
      });

      if (bankList.length > 0) {
        this.bankLedgerID = bankList[0].LID;
        this.getAPIData();
      }
      else {
        alert("Please select a valid bank ledger.");
      }
    }else {
      this.tempdata = [];
      this.dataSource = new MatTableDataSource(this.tempdata);
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  // copyData:any = this.tempdata

  // getData(){
  //   this.tempdata.forEach((s: any) => {
  //     s.IsEdit = false;
  //     s.tmpPaymentRef = s.PaymentRef;
  //     s.tmpReconDate = s.ReconDate;
  //     s.tmpPaymentMode = s.PaymentMode
  //   });
  //   this.dataSource = new MatTableDataSource(this.tempdata);
  // }

  //editReconsi() -- Edit Reconcile
  editReconsi(obj: any) {
    this.tempdata.forEach((s: any) => {
      s.IsEdit = false;
    });
    obj.IsEdit = true;
    obj.tmpPaymentMode = obj.PaymentMode;
  }

  editClose() {
    this.tempdata.forEach((s: any) => {
      s.IsEdit = false;
    });
  }


  getAPIData() {
    this.SpinnerService.show();

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let tmpData = [{
      ledgerID: this.bankLedgerID,
      fromDT: new Date(this.startDate).customFormat('#DD#-#MMM#-#YY#'),
      toDT: new Date(this.endDate).customFormat('#DD#-#MMM#-#YY#')
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'bankRecon',
      moduleID: 9,
      data: JSON.stringify(tmpData)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  //successResp - success  get handler
  successResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);

        if (reponseData) {
          this.SpinnerService.hide();
          let data = reponseData;

          this.tempdata = data.Table1;

          this.bankBalance = data.Table2[0].BankBalance;

          this.tempdata.forEach((s: any) => {
            s.IsEdit = false;
            s.tmpPaymentRef = s.PaymentRef;
            s.tmpReconDate = s.ReconDate;
            s.tmpPaymentMode = s.PaymentMode
          });


          let Reconciliation = $.grep(this.tempdata, function (i: any) { return i.VoucherID != 0 });
          if (Reconciliation.length > 0) {
            var tmpArrayWithRecn = [];
            var tmpArrayWithoutRecn = [];
            let arrayLength = Reconciliation.length;
            for (let i = 0; i < arrayLength; i++) {
              if (Reconciliation[i].ReconDate) {
                Reconciliation[i].ReconDate = new Date(Reconciliation[i].ReconDate).customFormat('#DD#-#MMM#-#YY#');
                tmpArrayWithRecn.push(Reconciliation[i]);
              }
              else {
                tmpArrayWithoutRecn.push(Reconciliation[i]);
              };
            }

            tmpArrayWithoutRecn = this.dlNaturalSort(tmpArrayWithoutRecn, "EffectiveDate");
            this.tempdata = tmpArrayWithRecn.concat(tmpArrayWithoutRecn);
            this.dataSource = new MatTableDataSource(this.tempdata);
            this.exportToExcel = this.tempdata;

            this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.matSort;
          }
          else {

            this.tempdata = [];

            this.dataSource = new MatTableDataSource(this.tempdata);
          }
        }
      }
    }
  }

  // alphaNumSort() - Sort array alphanumerically.
  alphaNumSort(name: string) {
    var reA = /[^a-zA-Z]/g; // Remove non-alphabets
    var reN = /[^0-9]/g;    // Remove non-numbers
    var reNStart = /[^0-9]/;
    return function (a: any, b: any) {

      var aStr = a[name].toLowerCase();
      var bStr = b[name].toLowerCase();

      //var aANumStart = aStr.match(reNStart).length > 0;
      //console.log(aANumStart);

      var aAName = aStr.replace(reA, "");
      var aBName = bStr.replace(reA, "");
      if (aAName === aBName) {
        var aANum = parseInt(a[name].replace(reN, ""), 10); // 10 is for decimal
        var aBNum = parseInt(b[name].replace(reN, ""), 10);
        return aANum === aBNum ? 0 : aANum > aBNum ? 1 : -1;
      }
      else {
        return aAName > aBName ? 1 : -1;
      }
    }
  }

  // dlNaturalSort() - Sorting
  dlNaturalSort(myList: any, columnName: string) {

    var arrayStartNum = [];
    var arrayNotStartNum = [];

    // First parse the list and classify between ones that start with number and ones that don't.
    for (var i = 0; i < myList.length; i++) {

      if (myList[i][columnName].match(/^[0-9].*$/) == null) {
        arrayNotStartNum.push(myList[i]);
      } else {
        arrayStartNum.push(myList[i]);
      }
    }

    // Sort both arrays independently.
    arrayStartNum.sort(this.alphaNumSort(columnName));
    arrayNotStartNum.sort(this.alphaNumSort(columnName));

    // Concat the arrays and return.
    return arrayStartNum.concat(arrayNotStartNum);
  }

  //failureResp - failure handler
  failureResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //Save() - Reconciliation Save
  Save(obj: any) {
    let reconDate: any = '';
    if (obj.tmpReconDate) {
      reconDate = new Date(obj.tmpReconDate).customFormat('#DD#-#MMM#-#YY#');
    }
    else if (obj.tmpReconDate) {
      reconDate = new Date(obj.tmpReconDate).customFormat('#DD#-#MMM#-#YY#');
    }

    let tmpData = [{
      voucherID: obj.VoucherID,
      ReconDate: reconDate,
      PaymentRef: obj.tmpPaymentRef,
      PaymntMode: obj.tmpPaymentMode
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'setRecon',
      moduleID: 8,
      data: JSON.stringify(tmpData)
    }];

    this.apiService.sendChange(myParams, this.successRecon.bind(this), this.failureReconResp.bind(this));
  }

  //successVchrEntry - success voucher entry handler
  successRecon(res: any) {
    if (res.error) {
      alert(res.message);
    }
    else {
      this.getAPIData();
    }
  }

  //failureResp - failure handler
  failureReconResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.sort = this.matSort;
  }

  fn_ChangeDate() {
    if (this.bankName) {
      this.getAPIData();
    }
  }

  public closeModal($event: any) {
    this.modalReference.close();
    this.getAPIData();
  }

  PrintReconciliation() {
    // this.appService.printReconciliationData(this.tempdata);

    var LID = this.bankLedgerID;
    var FDT = new Date(this.startDate).customFormat('#DD#-#MMM#-#YY#');
    var TDT = new Date(this.endDate).customFormat('#DD#-#MMM#-#YY#');

    window.open('reconciliationprint?LID=' + LID + '&FDT=' + FDT + '&TDT=' + TDT + '&BankName=' + encodeURIComponent(this.bankName), '_blank', 'Height= 900px, Width= 1100px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

  refresh() {
    this.getAPIData();
  }

  backBtn() {
    this.router.navigate(['/accounts']);
  }

  // Edit Voucher with Selected Row Date. 

  EditVoucher(content: any, voucherID: any) {
    this.modalReference = this.modalService.open(VoucherEntryComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'Edit-V', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.voucherID = voucherID;
    this.modalReference.componentInstance.mdlRefHide = this.modalReference
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
      this.getAPIData();
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openEditVoucher(voucherID: any){

    if(!this.right.AcctsVchrEdit){
      return;
    } 

    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP";
    }
    urlCheck += "/voucher"; 
     let target: string = "_blank";
     if(this.isWeb == false){
       target = "_self";
     }
 
    var win: any = window.open(urlCheck + '?voucherID=' + voucherID, target, 'height = 600, width = 1250');
    var timer = setInterval(() => {
      if(win != null){
        if (win.isSuccessVoucher) {
          clearInterval(timer);
          this.getAPIData();
          this.appService.updateVoucherEntered(1);
          win.close();
        }
      }
      if (win.closed) {
          clearInterval(timer);
      }
    }, 100);
  }

  // EditVoucher(content : any,voucherID: any) {
  //   this.modalReference = this.modalService.open(VoucherEntryComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
  //   this.modalReference.componentInstance.voucherID = voucherID;
  //   this.modalReference.componentInstance.mdlRefHide = this.modalReference
  //   this.modalReference.result.then((result: any) => {
  //     this.closeResult = `Closed with: ${result}`;
  //     this.getAPIData();
  //   }, (reason: any) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //   });
  // }

  // add voucher then selected row date auto..

  open(content: any, EffectiveDate: any) {
    this.modalReference = this.modalService.open(VoucherEntryComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'Edit-V', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.EffectiveDate = EffectiveDate;
    this.modalReference.componentInstance.mdlRefHide = this.modalReference
    this.modalReference.result.then((result: any) => {
      if (result == true) {
        this.getAPIData();
      }
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

    });
  }

  openNewWindowVoucher($event: any){
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP";
    }
    urlCheck += "/voucher"; 
   
    var win: any = window.open(urlCheck, '_blank', 'height = 600, width = 1250');
    var timer = setInterval(() => {
      if(win != null){
        if (win.isSuccessVoucher) {
          clearInterval(timer);
          //this.changingValue.next($event);
          //this.changingHeadValue.next($event);
          win.close();
          this.getAPIData();
        }
      }

      if (win.closed) {
          clearInterval(timer);
      }
    }, 100);
    //window.open("/voucher", '_blank', 'height = 600, width = 1250');
  }

  
  exportToExcelActivities() {
    
    var html = "";
    // Title
    html += "<table><tr>";
    html += "<th style='text-align: left;'>Bank Reconciliation</th>"
    html += "</table></tr>"; 

    html += "<table><tr></table></tr>";
    html += "<table><tr>";
    html += "<p><b>Ledger : </b>" + this.bankName + "<b>, Period : </b>" + new Date(this.startDate).customFormat("#DD#-#MMM#-#YYYY#") + " to " + new Date(this.endDate).customFormat("#DD#-#MMM#-#YYYY#") +  "</p>"
    html += "</table></tr>";

    html += "<table><tr>";
    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Voucher Date</th>";
    strHeader += "<th style='text-align: left;'>Voucher No.</th>";
    strHeader += "<th style='text-align: left;'>Payment Mode</th>";
    strHeader += "<th style='text-align: left;'>Payment Ref.</th>";
    strHeader += "<th style='text-align: left;'>Ledger</th>";
    strHeader += "<th style='text-align: right;'>Credit</th>";
    strHeader += "<th style='text-align: right;'>Debit</th>";
    strHeader += "<th style='text-align: right;'>Balance</th>";
    strHeader += "<th style='text-align: left;'>Recon. Date</th>";

    strHeader += "</tr>"
    html += strHeader;
    var body = "";
    this.exportToExcel.forEach((item:any, key:any) => {
      body += "<tr>";
      item.EffectiveDate = (item.EffectiveDate == null) ? '-' : new Date(item.EffectiveDate).customFormat("#DD#-#MMM#-#YYYY#");
      body += "<td style='text-align: left;'>" + item.EffectiveDate + "</td>";
      body += "<td style='text-align: left;'>" + item.VoucherNum + "</td>";
      body += "<td style='text-align: left;'>" + (item.PaymentMode != '0' ? item.PaymentMode : '-') + "</td>";
      body += "<td style='text-align: left;'>" +  (item.PaymentRef ? item.PaymentRef : '-') + "</td>";
      body += "<td style='text-align: left;'>" +  item.MainLedger + "</td>";
      //item.CrAmt = Number(item.CrAmt).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + (item.CrAmt ? item.CrAmt : '') + "</td>";
      //item.DbAmt = Number(item.DbAmt).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + (item.DbAmt ? item.DbAmt : '') + "</td>";
      var newBal = (item.newCloBal < 0 ? 'Cr': 'Db')
      item.CloBal = String(Number(item.CloBal).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") 
      body += "<td style='text-align: right;'>" +  item.CloBal + " " +  newBal + "</td>";
      item.ReconDate = (item.ReconDate == null) ? '-' : new Date(item.ReconDate).customFormat("#DD#-#MMM#-#YYYY#");
      body += "<td style='text-align: left;'>" + item.ReconDate + "</td>";

    body += "</tr>";
    })
    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Sheet1', 'Bank Reconciliation');
  }

  //removeRecon() - Reconciliation Remove
  removeRecon(obj: any){
    obj.tmpReconDate = "";
    obj.tmpPaymentRef = "";
    obj.tmpPaymentMode = "";
    this.Save(obj);
  }
}

declare global {
  interface Date {
    customFormat(formatString: any): string;
  }
}

Date.prototype.customFormat = function (formatString: any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}
